import { FC } from "react";
import { WinnerIdsTable } from "entities/wheel-raffle";
import { Pager } from "shared/ui";
import { PeopleIcon } from "shared/ui/icons";
import { RAFFLES_PER_PAGE } from "../../model/constants";
import { useClientPage } from "../../model/useClientPage";

import styles from "./RaffleDetailPage.module.css";

interface Props {
  fids: number[];
  participantsCount: number;
}

// Победители для не-организатора. Список участников бэк отдаёт только
// создателю (v1), поэтому здесь от участников — лишь их число.
export const PublicWinners: FC<Props> = ({ fids, participantsCount }) => {
  const { pageItems, page, pages, setPage } = useClientPage(fids);

  return (
    <>
      <div className={styles.peopleHeader}>
        <h2 className={styles.panelTitle}>Winners</h2>
        <span className={styles.count} title="Participants">
          <PeopleIcon />
          {participantsCount}
        </span>
      </div>
      {fids.length ? (
        <div className={styles.table}>
          <WinnerIdsTable
            fids={pageItems}
            offset={(page - 1) * RAFFLES_PER_PAGE}
          />
        </div>
      ) : (
        <p className={styles.placeholder}>No winners</p>
      )}
      <Pager page={page} pages={pages} onChange={setPage} />
    </>
  );
};
